import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ShiftProvider } from './context/ShiftContext';
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './components/AppLayout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import StoreDetailPage from './pages/StoreDetailPage';
import CreateAlertPage from './pages/CreateAlertPage';
import CreateReportPage from './pages/CreateReportPage';
import ReportListPage from './pages/ReportListPage';
import ReportDetailPage from './pages/ReportDetailPage';
import EditReportPage from './pages/EditReportPage';
import EmployeeDetailPage from './pages/EmployeeDetailPage';
import AddEditEmployeePage from './pages/AddEditEmployeePage';
import ShiftHistoryPage from './pages/ShiftHistoryPage';
import AlertListPage from './pages/AlertListPage';
import AlertDetailPage from './pages/AlertDetailPage';
import AlertEditPage from './pages/AlertEditPage';
import AdminPage from './pages/AdminPage';
import MonitorDetailPage from './pages/MonitorDetailPage';
import MonitorPerformancePage from './pages/MonitorPerformancePage';
import CoveragePage from './pages/CoveragePage';

function ProtectedPage({ children }: { children: React.ReactNode }) {
  return (
    <ProtectedRoute>
      <AppLayout>{children}</AppLayout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ShiftProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<ProtectedPage><DashboardPage /></ProtectedPage>} />
            <Route path="/alerts" element={<ProtectedPage><AlertListPage /></ProtectedPage>} />
            <Route path="/alerts/:alertId" element={<ProtectedPage><AlertDetailPage /></ProtectedPage>} />
            <Route path="/alerts/:alertId/edit" element={<ProtectedPage><AlertEditPage /></ProtectedPage>} />
            <Route path="/shifts" element={<ProtectedPage><ShiftHistoryPage /></ProtectedPage>} />
            <Route path="/stores/:storeId" element={<ProtectedPage><StoreDetailPage /></ProtectedPage>} />
            <Route path="/stores/:storeId/create-alert" element={<ProtectedPage><CreateAlertPage /></ProtectedPage>} />
            <Route path="/stores/:storeId/reports" element={<ProtectedPage><ReportListPage /></ProtectedPage>} />
            <Route path="/stores/:storeId/create-report" element={<ProtectedPage><CreateReportPage /></ProtectedPage>} />
            <Route path="/reports/:reportId" element={<ProtectedPage><ReportDetailPage /></ProtectedPage>} />
            <Route path="/reports/:reportId/edit" element={<ProtectedPage><EditReportPage /></ProtectedPage>} />
            <Route path="/stores/:storeId/employees/new" element={<ProtectedPage><AddEditEmployeePage /></ProtectedPage>} />
            <Route path="/employees/:employeeId" element={<ProtectedPage><EmployeeDetailPage /></ProtectedPage>} />
            <Route path="/employees/:employeeId/edit" element={<ProtectedPage><AddEditEmployeePage /></ProtectedPage>} />
            <Route path="/admin" element={<ProtectedPage><AdminPage /></ProtectedPage>} />
            <Route path="/admin/monitors/:monitorId" element={<ProtectedPage><MonitorDetailPage /></ProtectedPage>} />
            <Route path="/admin/monitors/:monitorId/performance" element={<ProtectedPage><MonitorPerformancePage /></ProtectedPage>} />
            <Route path="/admin/coverage" element={<ProtectedPage><CoveragePage /></ProtectedPage>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ShiftProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
